
import React from 'react';
import ApiService from './ApiService';
import { showModal, closeModal } from '../PageLayout/MainModal';
import { Button } from 'react-bootstrap';
import Spinner from '../PageLayout/Spinner';

class ProjectRequestService {
  static cancelRequest(projectRequest, cancelPendingCallback, cancelCallback) {
    const renderCancelRequestModal = (stateLabel) => {
      const title = 'Cancel request';
      const content = (
        <div>
          <p>
            Do you realy want to cancel project creation request {'"'}{projectRequest.name}{'"'} ?
          </p>
          <Button variant="outline-primary" onClick={() => closeModal()}>No</Button>{'\t'}
          <Button variant="primary" onClick={() => cancel()}>Yes{stateLabel}</Button>
        </div>
      );
      showModal(title, content, null);
    };

    const cancel = () => {
      if (cancelPendingCallback) {
        cancelPendingCallback();
      }
      ApiService.updateCreateProjectRequest({
        ...projectRequest
        , projectCreationRequestStatusId: 'CANCELLED'
      }).then(() => {
        cancelCallback();
        closeModal();
      });
      renderCancelRequestModal(<span> <Spinner /></span>);
    };
    renderCancelRequestModal(null);
  }
}

export default ProjectRequestService;
